import type { ICampaignType } from '../types';

import { removeDuplicates } from '~/utils/removeDuplicates';
import { CAMPAIGN_STATUS } from '~/constants/campaign';
import { useCampaignStore } from '../stores';
import { useMemo } from 'react';

export const useCampaignListingByType = (type: ICampaignType) => {
  const campaigns = useCampaignStore((state) => state.campaigns || []);

  const data = useMemo(() => {
    const listCampaigns = campaigns.filter((item) => item.type === type);
    return removeDuplicates(listCampaigns, ['id']);
  }, [campaigns, type]);

  const dataActive = useMemo(() => {
    return data.filter((item) => item.status !== CAMPAIGN_STATUS.DRAFT);
  }, [data]);

  return {
    data,
    dataActive,
  };
};
